// extracted by mini-css-extract-plugin
export var billingAddress = "_ya-g";
export var contactInfo = "_ya-d";
export var customerInfoContainer = "_ya-c";
export var customerInfoContainerMobile = "_ya-h";
export var customerInfoRow = "_ya-a";
export var customerInfoSection = "_ya-b";
export var fullWidthDividerMobile = "_ya-i";
export var imageContainer = "_ya-1";
export var paymentMethod = "_ya-e";
export var priceText = "_ya-6";
export var priceTextMobile = "_ya-7";
export var product = "_ya-0";
export var productImage = "_ya-2";
export var productInfo = "_ya-4";
export var productMobile = "_ya-9";
export var productTitle = "_ya-8";
export var quantityBadge = "_ya-3";
export var quantityText = "_ya-5";
export var shippingAddress = "_ya-f";